export const formatWhatsAppNumber = (phone) => {
  if (!phone) return '';
  // Remove all non-digits
  let cleanPhone = phone.replace(/\D/g, '');
  
  // If user entered 0535 000 0000, remove the first 0 -> 535 000 0000
  if (cleanPhone.startsWith('0')) {
    cleanPhone = cleanPhone.substring(1);
  }
  
  // Add 90 at the beginning if it doesn't exist
  if (!cleanPhone.startsWith('90')) {
    cleanPhone = `90${cleanPhone}`;
  }
  
  return cleanPhone;
};
